import { ReactElement } from 'react';
import { useMenuWithCart } from 'platform/contexts/MenuWithCart';
import { AdjustOrderBanner } from 'platform/components/order-confirmation/AdjustOrderBanner';
import { OrderItemCard } from './OrderItemCard';
import styles from './OrderConfirmation.module.scss';

export function WhatsInYourBox(): ReactElement {
  const { cart } = useMenuWithCart();

  if (!cart?.cartItems || cart.cartItems.length === 0) return <></>;

  const realCartItems = cart.cartItems.filter((item) => item.id !== null);
  const mealKitCount = realCartItems.filter((item) => item.productType === 'Meal Kit').length;
  const readyToEatCount = realCartItems.filter((item) => item.productType === 'Ready to Eat').length;
  const groceryCount = realCartItems.filter((item) => item.productType === 'Grocery').length;

  const summary = [
    mealKitCount > 0 && `${mealKitCount} Meal Kit${mealKitCount > 1 ? 's' : ''}`,
    readyToEatCount > 0 && `${readyToEatCount} Ready to Eat`,
    groceryCount > 0 && `${groceryCount} Grocery`,
  ].filter(Boolean)
    .join(', ');

  return (
    <div className={styles.whats_in_your_box}>
      <h3 className={styles.header}>
        Included in your order
        {summary && (
          <span className={styles.summary}>
            <span className={styles.pipe}> | </span>
            {summary}
          </span>
        )}
      </h3>
      <AdjustOrderBanner />
      <div className={styles.card_slider}>
        {/* filter out suggested cart items */}
        {cart.cartItems.filter((item) => item.id !== null)
          .map((item) => (
            <OrderItemCard key={item.skuId} item={item} />
          ))}
      </div>
    </div>
  );
}
